import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import {
  AllocationViewFilterProfileDto,
  AllocationViewFilterProfileModel,
  mapAllocationViewFilterProfileResponse,
} from '../../models';
import { AllocationViewProfilesEndpoint } from './../../constants';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewFilterProfileListService {
  constructor(private http: WrapperHttpService) {}

  getAllocationViewFilterProfiles(): Observable<AllocationViewFilterProfileModel[]> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.FilterProfilesAll}`;

    return this.http
      .withLoading()
      .get<AllocationViewFilterProfileDto[]>(url)
      .pipe(
        map((profiles: AllocationViewFilterProfileDto[]) =>
          (profiles ?? []).map(mapAllocationViewFilterProfileResponse),
        ),
      );
  }
}
